import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { SITE, waGeneral } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";

const FloatingButtons = () => (
  <motion.div
    initial={{ opacity: 0, scale: 0.6, y: 16 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-50 flex flex-col gap-3"
    data-testid="floating-contact-buttons"
  >
    <motion.a
      href={waGeneral()} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-button"
      onClick={() => trackEvent("whatsapp_click", { location: "floating_button" })}
      whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.92 }}
      className="group relative flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-black/20"
    >
      <MessageCircle className="h-6 w-6 md:h-7 md:w-7" />
      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-[#0F2F24] px-3 py-1.5 text-xs font-semibold text-white opacity-0 transition-opacity group-hover:opacity-100 md:block">
        WhatsApp Us
      </span>
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
    </motion.a>
    <motion.a
      href={`tel:${SITE.phoneRaw}`} aria-label="Call us now"
      data-testid="floating-call-button"
      onClick={() => trackEvent("phone_click", { location: "floating_button" })}
      whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.92 }}
      className="group relative flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-full bg-[#0F2F24] text-[#D99B26] shadow-xl shadow-black/20"
    >
      <Phone className="h-6 w-6 md:h-7 md:w-7" />
      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-[#0F2F24] px-3 py-1.5 text-xs font-semibold text-white opacity-0 transition-opacity group-hover:opacity-100 md:block">
        Call Now
      </span>
    </motion.a>
  </motion.div>
);

export default FloatingButtons;
